<div class="bottom-navbar-container text">
  <div class="bottom-navbar-item" *ngFor="let item of routeDatasC" [ngClass]="{ deactivate: activeItem !== item.id }" (click)="bottomMenuToogler(item.id)">
    <div class="bottom-navbar-item-icon">
      <div class="count-badge animation" *ngIf="item.count > 0">
        {{ item.count }}
      </div>
      <image-loader-utils [url]="item.svgUrl" [extraClasses]="'svg bottom-navbar-icon ' + (item.svgUrl === 'casino' ? 'casino' : '')"></image-loader-utils>
    </div>

    <ng-container *ngIf="item.id !== 15; else betslip">
      <div class="bottom-navbar-item-text">{{ item.name | translate }}</div>
    </ng-container>
    <ng-template #betslip>
      <div class="bottom-navbar-item-text">
        {{ item.name | translate }}
      </div>
    </ng-template>
  </div>
</div>
